import IIncome from "@/module/main/dto/customer/IIncome";
import IAmount from "@/module/main/dto/IAmount";
import IAddressFlags from "@/module/main/dto/customer/IAddressFlags";
import IBankAccount from "@/module/main/dto/customer/IBankAccount";
import IPrimaryPersonalDocument from "@/module/main/dto/customer/IPrimaryPersonalDocument";
import ISecondaryPersonalDocument from "@/module/main/dto/customer/ISecondaryPersonalDocument";
import Cohabitation from "@/module/main/dto/customer/CohabitationEnum";
import Education from "@/module/main/dto/customer/EducationEnum";
import HousingTenure from "@/module/main/dto/customer/HousingTenureEnum";
import IPerson from "@/module/main/dto/financing-v3/IPerson";
import IContact from "@/module/main/dto/financing-v3/IContact";
import IFinancingV3CustomerExtraData from "@/module/main/dto/financing-v3/IFinancingV3CustomerExtraData";
import IConsent from "@/module/main/dto/financing-v3/IConsent";

export default class Person implements IPerson
{
    public readonly addresses?: IAddressFlags[];
    public readonly bankAccount?: IBankAccount;
    public readonly birthplace?: string;
    public readonly childrenCount?: number;
    public readonly consents?: IConsent[];
    public readonly contacts?: IContact[];
    public readonly education?: Education;
    public readonly expenses?: IAmount;
    public readonly extraData?: IFinancingV3CustomerExtraData;
    public readonly firstName?: string;
    public readonly householdIncome?: IAmount;
    public readonly housingTenure?: HousingTenure;
    public readonly housingZipCode?: string;
    public readonly identificationNumber?: string;
    public readonly income?: IIncome;
    public readonly lastName?: string;
    public readonly cohabitation?: Cohabitation;
    public readonly nationality?: string;
    public readonly politicallyExposed?: boolean;
    public readonly primaryPersonalDocument?: IPrimaryPersonalDocument;
    public readonly secondaryPersonalDocument?: ISecondaryPersonalDocument;

    constructor(props: IPerson)
    {
        this.addresses = props.addresses;
        this.bankAccount = props.bankAccount;
        this.birthplace = props.birthplace;
        this.childrenCount = props.childrenCount;
        this.consents = props.consents;
        this.contacts = props.contacts;
        this.education = props.education;
        this.expenses = props.expenses;
        this.extraData = props.extraData;
        this.firstName = props.firstName;
        this.householdIncome = props.householdIncome;
        this.housingTenure = props.housingTenure;
        this.housingZipCode = props.housingZipCode;
        this.identificationNumber = props.identificationNumber;
        this.income = props.income;
        this.lastName = props.lastName;
        this.cohabitation = props.cohabitation;
        this.nationality = props.nationality;
        this.politicallyExposed = props.politicallyExposed;
        this.primaryPersonalDocument = props.primaryPersonalDocument;
        this.secondaryPersonalDocument = props.secondaryPersonalDocument;
    }
}
